/**
 * For docs check: live/docs/INTERACTION_WIDGET_SIGNALS.md
 */

/**
 * Signals emitted by interaction application.
 */
export enum EInteractionEmbedSignal {
  ACTIVE_POLL_CHANGED = 'ACTIVE_POLL_CHANGED',
  POLL_OPTION_VOTED = 'POLL_OPTION_VOTED',
  ACTIVE_QNA_CHANGED = 'ACTIVE_QNA_CHANGED',
  QUESTION_SUBMIT = 'QUESTION_SUBMIT',
}

export interface IInteractionEmbedSignal<T> {
  type: EInteractionEmbedSignal;
  data: T;
}
